// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__OkXwl","tagPrimary":"Tag_tagPrimary__9ObXq","tagSecondary":"Tag_tagSecondary__sdo1V","tagWarning":"Tag_tagWarning__SjEoG"};